<template>
  <div class="question">
    <div class="flex items-center justify-between">
      <span class="flex items-center">
        <span
          v-if="question.audienceName"
          class="question__avatar"
          :style="`background-color: ${question.audienceColor}`"
        >{{ (question.audienceName).charAt(0) }}</span>

        <span
          v-else
          class="question__avatar"
          style="background-color: #4f9af2;"
        >
          <AhaSvg
            size="xs"
            name="user-solid"
            view-box="0 0 16 17"
          />
        </span>

        <span class="mr-2 text-sm font-bold">{{ question.audienceName || 'Anonymous' }}</span>

        <span class="question__created-at">
          <AhaFormatter
            type="date"
            :value="question.createdAt"
          />
        </span>
      </span>

      <span
        v-if="question.status === 'pending'"
        class="flex items-center"
      >
        <AhaSpinner
          v-if="isApprovingQuestion"
          class="mr-3"
          variant="white"
        />

        <AhaSvgContainer
          v-else
          v-tooltip="'Approve'"
          class="mr-3 cursor-pointer bg-gray text-green-50 hover:bg-green-50 hover:text-base-0"
          @click="handleApproveQuestion(question)"
        >
          <AhaSvg name="check" />
        </AhaSvgContainer>

        <AhaSpinner
          v-if="isDismissingQuestion"
          variant="white"
        />

        <AhaSvgContainer
          v-else
          v-tooltip="'Dismiss'"
          class="cursor-pointer bg-gray text-red-50 hover:bg-red-50 hover:text-base-0"
          @click="handleDismissQuestion(question)"
        >
          <AhaSvg name="close" />
        </AhaSvgContainer>
      </span>

      <span
        v-if="question.status === 'approved' || question.status === 'dismissed'"
        class="flex items-center"
      >
        <AhaSvgContainer
          v-if="question.answered"
          v-tooltip="'This question has been answered'"
          class="cursor-pointer bg-gray"
        >
          <AhaSvg
            name="answered"
            viewBox="0 0 14 10"
            class="text-base-0"
          />
        </AhaSvgContainer>

        <template v-else>
          <AhaSpinner
            v-if="isRevertingQuestion"
            variant="white"
          />

          <AhaSvgContainer
            v-else
            v-tooltip="'Move back to Pending'"
            class="cursor-pointer bg-gray"
            @click="handleRevertQuestion(question)"
          >
            <AhaSvg
              name="replay"
              viewBox="0 0 14 14"
              class="text-base-0"
            />
          </AhaSvgContainer>
        </template>
      </span>
    </div>

    <div class="mt-2 text-base break-all">
      {{ question.title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    handleApproveQuestion: {
      type: Function,
      required: true,
    },
    handleDismissQuestion: {
      type: Function,
      required: true,
    },
    handleRevertQuestion: {
      type: Function,
      required: true,
    },
    isApprovingQuestion: {
      type: Boolean,
      required: true,
    },
    isDismissingQuestion: {
      type: Boolean,
      required: true,
    },
    isRevertingQuestion: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.question {
  @apply text-base-0 p-4 rounded-lg mb-3;

  background: rgba(10, 10, 10, 0.2);
}

.question:last-child {
  @apply mb-0;
}

.question__avatar {
  @apply inline-flex justify-center items-center;
  @apply rounded-full uppercase border-base-0 text-xs mr-2;

  border-width: 1px;
  width: 20px;
  height: 20px;
}

.question__created-at {
  @apply text-xs;

  color: rgba(255, 255, 255, 0.65);
}

.bg-gray {
  background-color: rgba(82, 95, 127, 0.5);
}
</style>
